;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"3.2.4"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import {
	init,
	browserTracingIntegration,
	replayIntegration,
	feedbackIntegration,
} from '@sentry/nextjs';
import { theme } from './utils/theme';

const isSentryEnabled = process.env.NEXT_PUBLIC_SENTRY_ENABLED === 'true';

if (isSentryEnabled) {
	init({
		dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
		environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
		tracePropagationTargets: ["localhost", process.env.NEXT_PUBLIC_API_URL!],
		release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
		dist: process.env.NEXT_PUBLIC_RELEASE_DIST,
		integrations: [
			browserTracingIntegration(),
			replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
				maxReplayDuration: 2 * 60 * 1000,
				networkDetailAllowUrls: [process.env.NEXT_PUBLIC_API_URL!]
			}),
			feedbackIntegration({
				// Additional SDK configuration goes in here, for example:
				autoInject: false,
				colorScheme: "light",
				themeLight: {
					fontFamily: theme.typography.fontFamily,
					submitBackground: theme.palette.primary.brand,
					submitBackgroundHover: theme.palette.warning.main
				}
			})
		],
		// Performance Monitoring
		tracesSampleRate: 0.05,
		// Session Replay
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 1.0,
		maxBreadcrumbs: 50,
		ignoreErrors: [
			"Minified React error",
			"evaluating 't.digest'",
			"reading 'digest'",
			"Could not load \"marker\"",
			"Database deleted by request of the user", // known firebase error in some versions of safari
			"evaluating 'e.createObjectStore'",
			"attempted to hard navigate to the same URL",
			"Failed to execute 'transaction' on 'IDBDatabase'", // known firebase error in some versions of safari
			"Attempt to get a record from database without an in-progress transaction", // known firebase error in some versions of safari
			"Can't find variable: IFrameMessageHandler", // Don't know what causes this error, but it's really often and doesn't break any user flows
			"Can't find variable: _AutofillCallbackHandler", // Don't know what causes this error, but it's really often and doesn't break any user flows
			"Failed to load Stripe.js", // doesn't seem to be a widespread error as people purchase tickets and doesn't complain. Usually happen on event screen and not checkout
			"maps-api-v3/api", // rare, spammy, and I have no idea how to fix it
			"t is undefined", // doesn't tell any actual info. Comes from firebase init script
			"Abort due to cancellation of share.",
			"Could not load \"util\"", // maps-api
			"Could not load \"infowindow\"", // maps-api
			"Can't find variable: HTMLDialogElement",  // maps-api
		]
	});
}
